import {
  Badge,
  Box,
  Image,
  Heading,
  HStack,
  Button,
  Text,
  Spinner,
  Link as ChakraLink,
} from "@chakra-ui/react";
import React, { useContext, useEffect, useState } from "react";

import PrepleafLogo from "../../../../assets/images/CoursePrograms/prepleaf-logo.svg";

import CourseCardTag from "../../CourseCardTag";
import { Link, useHistory, useLocation } from "react-router-dom";

import { AppContext } from "../../../../context/ApplicationContext";
import EmailVerifyModal from "../../../../components/common/general/EmailVerifyModal/EmailVerifyModal";
import useSnackBar from "../../../../components/common/general/SnackBar";
import { axiosErrorHandler } from "../../../../api/utils/error";
import { createApplication } from "../../../../api/utils/api";
import {
  ApplicationStatus,
  GetApplicationType,
  GetUnappliedBatch,
} from "../../../../api/schemas/schema";
import MasaiXCourseImage1 from "../../../../assets/images/CoursePrograms/MasaiXCourseImage1.svg";
import MasaiXCourseImage2 from "../../../../assets/images/CoursePrograms/MasaiXCourseImage2.svg";
import MasaiXCourseImage3 from "../../../../assets/images/CoursePrograms/MasaiXCourseImage3.svg";
import MasaiOneCourseImage1 from "../../../../assets/images/CoursePrograms/MasaiOneCourseImage1.svg";
import CAPCourseImage from "../../../../assets/images/CoursePrograms/CAPCourseImage.svg";
import NewBadgeRightGif from "../../../../assets/images/CoursePrograms/NewBadgeRight.gif";

import MasaiOneCourseImage2 from "../../../../assets/images/CoursePrograms/MasaiOneCourseImage2.svg";
import MasaiOneCourseImage3 from "../../../../assets/images/CoursePrograms/MasaiOneCourseImage3.svg";
import ScholarCourseImage1 from "../../../../assets/images/CoursePrograms/ScholarCourseImage1.svg";
import ScholarCourseImage2 from "../../../../assets/images/CoursePrograms/ScholarCourseImage2.svg";
import ScholarCourseImage3 from "../../../../assets/images/CoursePrograms/ScholarCourseImage3.svg";
import {
  BriefcaseOutline,
  CalendarIcon,
  IndianRupee,
  TagOutline,
} from "../../../../assets/icons/components";
import dayjs from "dayjs";
import { ModalTemplate } from "../../../../components/common/general";
import CourseRestrictModalContent from "../../CourseRestrictModalContent";
import gtag_report_conversion from "../../../../components/common/utils/ads-tracking";
import { sendTrackingEvent } from "../../../../components/common/utils/gtm";
import PeopleSpeak from "../../../../assets/icons/components/Others/PeopleSpeak";
import { CheckIcon } from "@chakra-ui/icons";
import { useMatomo } from "@datapunt/matomo-tracker-react";
import { isCourseProgramsIntersectsProfilePrograms } from "../../../../components/common/utils/isProgramPresent";

interface Props {
  applicationID?: string;
  batchData: GetUnappliedBatch;
  applicationStatus?: ApplicationStatus;
  loading?: boolean;
  application?: GetApplicationType;

  autoApplyCourseApplication?: (autoApplyCourseId: number) => void;
}
const ScholarMasaiXCourseCard = ({
  applicationID,
  batchData,
  applicationStatus,
  loading,
  autoApplyCourseApplication,
}: Props) => {
  // const { image, tag, badge1, badge2, badge3, header1, header2, points } = newCourse;
  const state = useContext(AppContext)[0];

  const startDate = dayjs(batchData?.start_date).format("DD MMM YYYY");

  const [showCourseRestrictModal, setShowCourseRestrictModal] = useState<boolean>(false);
  const [emailVerificationCourseId, setEmailVerificationCourseId] = useState<number | null>(null);
  const [message, setMessage] = useState<string>("");

  const programLevel: number = batchData?.course.level ?? 0;

  const [type, setType] = useState<string | "">("");

  useEffect(() => {
    if (
      isCourseProgramsIntersectsProfilePrograms(batchData?.course?.course_programs, [
        {
          id: 1,
          name: "Scholar",
        },
      ])
    ) {
      setType("scholar");
    } else if (
      isCourseProgramsIntersectsProfilePrograms(batchData?.course?.course_programs, [
        {
          id: 2,
          name: "Masai_One",
        },
      ])
    ) {
      setType("masai_one");
    } else if (
      isCourseProgramsIntersectsProfilePrograms(batchData?.course?.course_programs, [
        {
          id: 3,
          name: "MasaiX",
        },
      ])
    ) {
      setType("masaix");
    } else if (
      isCourseProgramsIntersectsProfilePrograms(batchData?.course?.course_programs, [
        {
          id: 4,
          name: "CAP",
        },
      ])
    ) {
      setType("cap");
    }
  }, []);

  const course = batchData.course;

  const isIneligible =
    "ineligibility_reasons" in batchData &&
    batchData?.ineligibility_reasons &&
    Object.values(batchData.ineligibility_reasons).length > 0;
  // TODO : add program type logic here
  const tag =
    type === "scholar"
      ? {
          text: "Seats Filling Fast",
          color: "ms-red.500",
          bgColor: "ms-red.50",
        }
      : type === "masaix"
      ? {
          text: "zero upfront fee".toUpperCase(),
          color: "ms-purple.500",
          bgColor: "ms-purple.50",
        }
      : type === "cap"
      ? {
          text: "prepaid".toUpperCase(),
          color: "ms-purple.500",
          bgColor: "ms-purple.50",
        }
      : batchData?.tag;
  let badge1 = "";
  const badge2 = batchData?.course.course_type === "FULL_TIME" ? "Full Time" : "Part Time";
  let badge3 = "";
  // TODO : add program type logic here
  const header1 =
    type === "scholar" || type === "masaix"
      ? `Level ${programLevel}`
      : batchData?.course.name === "Full Stack Web Development" && type === "masai_one"
      ? ""
      : ""; // course level
  const header2 =
    batchData?.course.name === "Full Stack Web Development" && type === "masaix"
      ? "Full Stack Web Development"
      : batchData?.course.name;

  let image: string = ScholarCourseImage1;
  let ISA_CTC = "";
  // TODO : add program type logic here
  if (type === "scholar") {
    switch (batchData?.course.name) {
      case "Analytics 101":
        image = ScholarCourseImage1;
        badge1 = "1st year College";
        badge3 = "Requires No Background in Analytics";
        break;
      case "Programming 101":
        badge1 = "1st, 2nd & Pre-final year";
        badge3 = "Requires No Background in Coding";
        image = ScholarCourseImage2;
        break;
      case "Programming: Advanced":
        image = ScholarCourseImage3;
        badge1 = "1st, 2nd & Pre-final year";
        badge3 = "requires coding knowledge";
        break;
    }
  } else if (type === "masaix") {
    switch (batchData?.course.name) {
      case "Full Stack Development":
        badge1 = "working professionals";
        badge3 = "requires no coding experience";
        image = MasaiXCourseImage2;
        ISA_CTC = "5";
        break;
      case "Data Analytics":
        image = MasaiXCourseImage1;
        badge1 = "working professionals";
        badge3 = "requires No analytics experience";
        ISA_CTC = "5";
        break;
      case "Backend Development":
        image = MasaiXCourseImage3;
        badge1 = "working professionals";
        badge3 = "minimum 1 year of coding experience";
        ISA_CTC = "10";
        break;
    }
  } else if (type === "masai_one") {
    switch (batchData?.course.name) {
      case "Full Stack Web Development":
        badge1 = "Graduates";
        badge3 = "requires no coding experience";
        image = MasaiOneCourseImage1;
        ISA_CTC = "5";
        break;
      case "Data Analytics":
        image = MasaiOneCourseImage3;
        badge1 = "Final Year Students";
        badge3 = "requires no analytics experience";
        ISA_CTC = "5";
        break;
      case "Full Stack Development":
        image = MasaiOneCourseImage2;
        badge1 = "Final Year Students";
        badge3 = "requires no coding experience";
        ISA_CTC = "5";
        break;
    }
  } else if (type === "cap") {
    switch (batchData?.course.name) {
      case "Career Accelerator Program":
        badge1 = "open to all";
        // badge3 = "requires no coding experience";
        image = CAPCourseImage;
        break;
    }
  }

  // const coursePrice = state.applicationData?.batch_campus.batch.course_price || 0;
  // TODO : add program type logic here
  const points =
    type === "scholar"
      ? [
          {
            icon: <CalendarIcon />,
            text:
              course.name !== "Programming: Advanced"
                ? `Course starts on ${startDate}`
                : "Course date will be announced soon",
          },
          {
            icon: <PeopleSpeak />,
            text: programLevel === 1 ? `Taught in Hinglish (Hindi, English)` : `Taught in English`,
          },
          {
            icon: <IndianRupee />,
            text:
              programLevel === 1
                ? `Pay ₹2,500 per month for 6 months`
                : `Pay ₹5000 per month for 6 months`,
          },
          {
            icon: <CheckIcon />,
            text: "Internship Opportunities",
          },
        ]
      : type === "cap"
      ? [
          {
            icon: <CalendarIcon />,
            text: `Course starts on ${startDate}`,
          },
          {
            icon: <BriefcaseOutline />,
            text: "Guaranteed job of 5lpa or above",
          },
          {
            icon: <IndianRupee />,
            text: "Pay ₹5,000 to reserve your seat",
          },
          {
            icon: <TagOutline />,
            text: "Avail Full Refund Within 15 day free trial",
          },
        ]
      : [
          { icon: <CalendarIcon />, text: `Course starts on ${startDate}` },

          { icon: <IndianRupee />, text: `Pay after placement of ${ISA_CTC} LPA or above` },
        ];

  const [showEmailVerifyModal, setShowEmailVerifyModal] = useState(false);
  const [isOTPModalOpen, setIsOTPModalOpen] = React.useState(false);
  const [showVerificationSuccessModal, setShowVerificationSuccessModal] = React.useState(false);
  const [showUpdateEmailModal, setShowUpdateEmailModal] = React.useState(false);
  const history = useHistory();
  const snackbar = useSnackBar();

  const handleApplyNow = async () => {
    // * for ads apply now - 14-2-22
    gtag_report_conversion("wwasCPzGnKEDEJLKzuMB");
    const batch_campus_id =
      batchData && batchData.batch_campuses && batchData?.batch_campuses.length >= 1
        ? batchData?.batch_campuses[0].id
        : null;
    if (!batch_campus_id) return;
    try {
      // create masaix or scholar application
      if (state.profileData?.slug) {
        await createApplication({
          profile_slug: state.profileData.slug,
          batch_campus_id: batch_campus_id, // TODO: change this to dynamic value
        }).then((res) => {
          // TODO : add program type logic here
          if (type === "scholar") {
            history.push(`/batch/${res.batch_campus.batch_id}/${res.slug}/instructions`); //TODO: change this to dynamic value
          }
          if (type === "cap") {
            history.push(`/batch/${res.batch_campus.batch_id}/${res.slug}/application-created`);
          } else {
            history.push(`/batch/${res.batch_campus.batch_id}/${res.slug}/applicant-details`); //TODO: change this to dynamic value
          }
          snackbar.success("Application created successfully!");
        });
      }
    } catch (err) {
      const e = axiosErrorHandler(err);
      if (typeof e === "object" && "message" in e) {
        if (typeof e.message === "string" && e.message.includes("access-restricted,")) {
          setShowCourseRestrictModal(true);
          setMessage(e.message.split("access-restricted,")[1]);
        } else snackbar.error(e.message);
      } else {
        snackbar.error("something went wrong");
      }
    }
  };
  const location = useLocation();
  const { trackEvent } = useMatomo();
  useEffect(() => {
    if (showVerificationSuccessModal && emailVerificationCourseId) {
      snackbar.success("Email verified successfully");
      setEmailVerificationCourseId(null);
      setShowVerificationSuccessModal(false);
      autoApplyCourseApplication && autoApplyCourseApplication(emailVerificationCourseId as number);
    }
  }, [showVerificationSuccessModal]);
  const getUrlForRedirectionIfNeeded = (): string | null => {
    if (
      state.isScholar &&
      course.course_programs?.some((course_program) =>
        ["MasaiX", "Masai_One"].includes(course_program.program?.name || "")
      )
    ) {
      return (
        window.location.href.replace("prepleaf.com", "masaischool.com").split("?")[0] +
        `?autoApplyCourseId=${course.id}`
      );
    } else if (
      !state.isScholar &&
      course.course_programs?.some((course_program) =>
        ["Scholar", "CAP"].includes(course_program.program?.name || "")
      )
    ) {
      return (
        window.location.href.replace("masaischool.com", "prepleaf.com").split("#")[0] +
        `#/?autoApplyCourseId=${course.id}`
      );
    } else {
      return null;
    }
  };
  return (
    <>
      <Box
        h="fit-content"
        height="100%"
        d={"flex"}
        flexDirection={"column"}
        borderRadius="ms-24"
        border="ms-1"
        borderColor="ms-grey.200"
      >
        <Box position="relative" borderRadius="ms-16">
          <Image
            position={"absolute"}
            src={PrepleafLogo}
            w={"82px"}
            top={"ms-16"}
            right={"ms-16"}
            // TODO : add program type logic here
            d={type === "scholar" ? "block" : "none"}
          />
          <Image src={image} w={"100%"} />

          {type === "cap" && (
            <Image
              position="absolute"
              pointerEvents={"none"}
              w={"99px"}
              right={["-16px"]}
              top="-62px"
              src={NewBadgeRightGif}
              alt="badge"
            />
          )}

          {tag && (
            <Box position="absolute" top="-4px" left={["-24px"]}>
              <CourseCardTag
                text={typeof tag.text === "string" ? tag.text : "NA"}
                color={typeof tag.color === "string" ? tag.color : "ms-red.500"}
                bgColor={typeof tag.bgColor === "string" ? tag.bgColor : "ms-red.50"}
              />
            </Box>
          )}
        </Box>
        <Box h={"100%"} p={"ms-16"} d={"flex"} flexDirection={"column"}>
          <Box d={"flex"} flexDirection={"column"}>
            <Box>
              <Badge mr={"ms-8"} variant={"purple"}>
                {badge1}
              </Badge>
              <Badge variant={"brick"}> {badge2}</Badge>
            </Box>
            {
              <Box>
                {badge3 && (
                  <Badge mt={"ms-8"} mr={"ms-8"} variant={"cyan"}>
                    {badge3}
                  </Badge>
                )}
              </Box>
            }
            <Box mt={"ms-16"}>
              <Heading color={"ms-grey.800"} mb={"ms-4"} as="h5">
                {header1}
              </Heading>

              <Heading color={"ms-grey.900"} as="h3">
                {header2}
              </Heading>
            </Box>
            <Box my={"ms-16"} display={"grid"} rowGap={"ms-12"}>
              {points.map((point) => (
                <Box key={point.text} display={"flex"} alignItems={"center"}>
                  <Box alignSelf={"flex-start"}>
                    {point.icon &&
                      React.cloneElement(point.icon, { boxSize: "20px", color: "ms-grey.500" })}
                  </Box>
                  <Text ml={"ms-8"} textStyle="body2-md" color={"ms-grey.800"}>
                    {point.text}
                  </Text>
                </Box>
              ))}
            </Box>
          </Box>
          {/* TODO : add program type logic here */}
          <HStack justify="flex-end" spacing="ms-32" align="center" mt={"auto"}>
            <>
              {type === "masaix" && programLevel === 2 ? (
                <ChakraLink href={`https://masaischool.com/courses/backend-part-time/`} isExternal>
                  <Button
                    variant="link"
                    size="md"
                    onClick={() => {
                      // dash-FTFSWD-view_details

                      const courseNameWords = course.name.split(" ");
                      let courseNameLetters = "";
                      courseNameWords.forEach((word) => (courseNameLetters += word[0]));
                      const courseType = course.course_type === "FULL_TIME" ? "FT" : "PT";
                      const eventName = `dash-${courseType}${courseNameLetters}-view_details`;
                      sendTrackingEvent({ event: eventName, eventLabel: location.pathname });
                    }}
                  >
                    view details
                  </Button>
                </ChakraLink>
              ) : (
                <>
                  {batchData && (
                    <Link to={`/courses/${batchData.id}/details`}>
                      <Button
                        variant="link"
                        size="md"
                        onClick={() => {
                          // dash-FTFSWD-view_details

                          const courseNameWords = course.name.split(" ");
                          let courseNameLetters = "";
                          courseNameWords.forEach((word) => (courseNameLetters += word[0]));
                          const courseType = course.course_type === "FULL_TIME" ? "FT" : "PT";
                          const eventName = `dash-${courseType}${courseNameLetters}-view_details`;
                          sendTrackingEvent({ event: eventName, eventLabel: location.pathname });
                        }}
                      >
                        view details
                      </Button>
                    </Link>
                  )}
                </>
              )}
            </>
            {applicationStatus ? (
              <Box>
                <Link
                  to={
                    state.profileData?.email_verified
                      ? `/batch/${batchData?.id}/${applicationID}/instructions`
                      : "#"
                  }
                >
                  <Button
                    disabled={
                      isCourseProgramsIntersectsProfilePrograms(
                        course?.course_programs,
                        state.profileData?.programs
                      )
                        ? false
                        : true
                    }
                    variant="primary"
                    size="md"
                    onClick={() => {
                      const urlForRedirection = getUrlForRedirectionIfNeeded();
                      if (urlForRedirection) {
                        window.location.href = urlForRedirection;
                      }
                      if (state.profileData?.email_verified) {
                        // TODO: send gtm event
                        const courseNameWords = course.name.split(" ");
                        let courseNameLetters = "";
                        courseNameWords.forEach((word) => (courseNameLetters += word[0]));
                        const courseType = course.course_type === "FULL_TIME" ? "FT" : "PT";
                        const eventName = `dash-${courseType}${courseNameLetters}-continue`;
                        sendTrackingEvent({ event: eventName, eventLabel: location.pathname });
                      } else {
                        if (state.profileData?.email) {
                          setShowEmailVerifyModal(true);
                        } else {
                          setShowUpdateEmailModal(true);
                        }
                        setEmailVerificationCourseId(course.id);
                      }
                    }}
                  >
                    continue
                  </Button>
                </Link>
              </Box>
            ) : (
              <Button
                position={loading ? "relative" : "static"}
                variant="primary"
                size="md"
                onClick={() => {
                  let source = undefined;
                  if (
                    isCourseProgramsIntersectsProfilePrograms(batchData?.course?.course_programs, [
                      {
                        id: 4,
                        name: "CAP",
                      },
                    ])
                  ) {
                    const isIneligiblePage = location.pathname.includes("ineligible");
                    const isApplicationClosedPage = location.pathname.includes(
                      "application-closed"
                    );
                    const isMsatFailedPage = location.pathname.includes("reject/msat");

                    source = isIneligiblePage
                      ? "ONWARD_INELIGIBLE_PAGE"
                      : isApplicationClosedPage
                      ? "ONWARD_APPLICATION_CLOSED_PAGE"
                      : isMsatFailedPage
                      ? "ONWARD_MSAT_FAILED_PAGE"
                      : undefined;
                  }
                  const urlForRedirection = getUrlForRedirectionIfNeeded();
                  if (urlForRedirection) {
                    window.location.href = urlForRedirection + (source ? `&source=${source}` : "");
                  }
                  if (state.profileData?.email_verified) {
                    //TODO: send gtm event
                    const courseNameWords = course.name.split(" ");
                    let courseNameLetters = "";
                    courseNameWords.forEach((word) => (courseNameLetters += word[0]));
                    const courseType = course.course_type === "FULL_TIME" ? "FT" : "PT";
                    const eventName = `dash-${courseType}${courseNameLetters}-apply_now`;

                    trackEvent({
                      category: "Dashboard",
                      action: "Apply",
                      name: eventName,
                      value: 300,
                    });
                    sendTrackingEvent({ event: eventName, eventLabel: location.pathname });
                    handleApplyNow();
                  } else {
                    if (state.profileData?.email) {
                      setShowEmailVerifyModal(true);
                    } else {
                      setShowUpdateEmailModal(true);
                    }
                    setEmailVerificationCourseId(course.id);
                  }
                }}
                disabled={isIneligible || loading}
              >
                {isIneligible ? "ineligible" : type === "cap" ? "reserve seat" : "apply now"}
                {loading && (
                  <Spinner
                    speed={"0.5s"}
                    thickness={"2px"}
                    size={"md"}
                    position={"absolute"}
                    color={"ms-blue.500"}
                  />
                )}
              </Button>
            )}
          </HStack>
        </Box>
      </Box>
      {/* Course Restrict modal */}
      <ModalTemplate
        title=""
        isOpen={showCourseRestrictModal}
        onClose={() => {
          setShowCourseRestrictModal(false);
        }}
        marginX={2}
        maxWidth="484px"
        showCloseButtonIcon={true}
      >
        <CourseRestrictModalContent
          message={message}
          setShowCourseRestrictModal={setShowCourseRestrictModal}
        />
      </ModalTemplate>
      <EmailVerifyModal
        showEmailVerifyModal={showEmailVerifyModal}
        setShowEmailVerifyModal={setShowEmailVerifyModal}
        isOTPModalOpen={isOTPModalOpen}
        setIsOTPModalOpen={setIsOTPModalOpen}
        showVerificationSuccessModal={showVerificationSuccessModal}
        setShowVerificationSuccessModal={setShowVerificationSuccessModal}
        showUpdateEmailModal={showUpdateEmailModal}
        setShowUpdateEmailModal={setShowUpdateEmailModal}
      />
    </>
  );
};

export default ScholarMasaiXCourseCard;
